import { JSONSchemaBridge } from "uniforms-bridge-json-schema";
import { initJSONschema } from "./initJSONschema";

interface JsonSchema {
  type: string;
  properties: any;
  required: string[];
}

export const initJSONschemaForObject = <T>(
  a: Record<string, string | any>
): JSONSchemaBridge => {
  const schema: JsonSchema = {
    type: "object",
    properties: {},
    required: []
  };

  Object.entries(a).forEach(([k, v]) => {
    if (typeof v === "string") {
      schema.properties[k] = { type: v };
    } else {
      schema.properties[k] = v;
    }
    schema.required.push(k);
  });
  return initJSONschema<T>(schema);
};
